import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Route } from 'react-router-dom'
import { selectors as session_selectors } from './sagas/session';
import { selectors as account_selectors } from './sagas/account';
import { actions } from './sagas/session'
import Login from './Login'
import { bindActionCreators } from 'redux'
import { client } from './http/reduxFetch'
import Intercom from 'react-intercom';

function checkKey (action) {
  let jwt = getNewKey()
  let foo = jwt.then( response => {
    action(response.key, response.jwt)
    return response.jwt && response.key ? true : false
  })
  .catch (error => {
    return false
  })
  return foo
}

function getSessionKey() {
  return sessionStorage.getItem('session')
}

function getNewKey() {
  let session_key = getSessionKey()
  let options = {
    method: 'POST',
    body: JSON.stringify({ key: session_key })
  }
  return client.fetch('/refresh', options)
}

class PrivateRoute extends Component {

  async componentToRender () {
    return this.props.token !== undefined
      ? this.props.component
      : await checkKey(this.props.setKeyToken)
        ? this.props.component
        : this.props.history.push('/') && Login
  }


  componentWillMount () {
    this.setState({ loading: true })
    this.componentToRender().then( response => {
      this.setState({ loading: false, component: response, token: this.props.token })
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({component: nextProps.component})
    this.componentToRender().then( response => {
      this.setState({ loading: false, component: response, token: this.props.token })
    })
  }

  company = () => {
    return this.props.account_info
      && {
        total_future_inventory: this.props.account_info['totalFutureInventory'],
        number_of_products: this.props.account_info['totalProducts'],
        company_id: this.props.account_info && this.props.account_info['id']
      }
  }

  user = () => {
    return(
      {
        user_id: this.props.user_id,
        email: this.props.email,
        role: this.props.role,
        total_future_inventory: this.props.account_info && this.props.account_info['totalFutureInventory'],
        total_products: this.props.account_info && this.props.account_info['totalProducts'],
        total_scans: this.props.account_info && this.props.account_info['totalScans'],
        complete: this.props.account_info && this.props.account_info['complete?'],
        company: {
          ...this.company()
        }
      }
    )
  }

  render () {
    !this.state.loading && this.props.role && !checkRole(this.props.minimumRouteRole || 'user', this.props.role) && this.props.history.push('/wrong')
    return(
        !this.state.loading &&
          this.state &&
          this.props.history && this.props.role && checkRole(this.props.minimumRouteRole || 'user', this.props.role) &&
          this.state.component
        ?
         <div>
            <Route
              {...this.props}
              token={ this.state.token }
              location={ this.props.location }
              component={ this.state.component }
            />
           <Intercom appID="bhil3d7i" { ...this.user() } />
          </div>
        : null
      )
  }
}



const checkRole = (minRole, role) => {
  return roleCanView()[role].includes(minRole)
}

const roleCanView = () => ({
  'admin': ['admin', 'accountant', 'user', 'non_user'],
  'accountant': ['accountant', 'user', 'non_user'],
  'user': ['non_user', 'user'],
  'non_user': []
})

const mapStateToProps = (store) => ({
  account_info: account_selectors.account_info(store),
  token: session_selectors.token(store),
  role: session_selectors.role(store),
  user_id: session_selectors.user_id(store),
  email: session_selectors.email(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false,
})(PrivateRoute);



// WEBPACK FOOTER //
// ./src/PrivateRoute.jsx